module.exports = __webpack_public_path__ + "static/media/pricesplash-prio.6e11ec45.svg";